const freestandingLayout = () =>
`
  <LinkFreeStanding>freestanding</LinkFreeStanding>
`;

const widgetsLayout = () =>
`
  <LinkWidget>widgets</LinkWidget>
`;

const withintextLayout = () =>
`
  this is a <LinkWithinText>link</LinkWithinText> within text
`;

const headingLayout = () =>
`
  <LinkHeading>heading</LinkHeading>
`;

const actionLayout = () =>
`
  <LinkAction>action</LinkAction>
`;

const linksTemplates = {
  freestanding: freestandingLayout(),
  widget: widgetsLayout(),
  withintext: withintextLayout(),
  heading: headingLayout(),
  action: actionLayout()
};

export default linksTemplates;



// WEBPACK FOOTER //
// ./src/containers/elements/Links/constants/linksTemplates.js